const PREFIX = 'OAUTH_APPLICATION_'

export const OAUTH_APPLICATION_INIT = `${PREFIX}INIT`

export const OAUTH_APPLICATION_SHOW_ID_SECRET_MODAL = `${PREFIX}SHOW_ID_SECRET_MODAL`

export const OAUTH_APPLICATION_HIDE_ID_SECRET_MODAL = `${PREFIX}HIDE_ID_SECRET_MODAL`

export const OAUTH_APPLICATION_SUBMIT_ACTION = `${PREFIX}SUBMIT_ACTION`

export const OAUTH_APPLICATION_SET_FORM_STATE = `${PREFIX}SET_FORM_STATE`



// WEBPACK FOOTER //
// app/javascript/components/actions/oauthApplication/constants.js